<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
  <li>
    <a [routerLink]="['/']">Home</a>
  </li>
  <li>Unapproved Library Task List</li>

</ul>
<section class="card">
  <div class="card-header">
    <span class="cat__core__title">
      <strong>Unapproved Library Task List</strong>
    </span>
  </div>

  <div class="row">

    <div class="col-md-12" id="committeeTabContainer">
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" (click)="onclickEventTask()" data-target="#eventBasedTaskDetails" data-toggle="tab"
            href="javascript: void(0);" role="tab" aria-selected="true">Event Based Task</a>
        </li>
        <li class="nav-item">
          <a class="nav-link " (click)="onclickPeriodicTask()" data-target="#periodicTaskTab" data-toggle="tab"
            href="javascript: void(0);" role="tab">Periodic Based Task</a>
        </li>
      </ul>

      <div class="tab-content">

        <div class="tab-pane active" id="eventBasedTaskDetails" role="tabcard">
          <section class="card">


            <section class="card search-box">
              <div class="card-header" (click)="toggleSearchCollapse()" style="cursor: pointer;">Modify Search <span
                  class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
              <div id="search-div" class="card-block" *ngIf="!isSearchCollapsed">
                <!-- Row 1: Labels for Radio Options -->
                <div class="row filter-row-labels">
                  <div class="col-md-4">
                    <label class="form-control-label">User defined / Pre defined</label>
                  </div>
                  <div class="col-md-4">
                    <label class="form-control-label">Emails</label>
                  </div>
                  <div class="col-md-4">
                    <label class="form-control-label">Approve Status</label>
                  </div>
                </div>

                <!-- Row 2: All Radio Button Options -->
                <div class="row filter-row-options">
                  <div class="col-md-4">
                    <div class="radio-options-group">
                      <div class="md-radio md-radio-inline">
                        <input id="IsPredefinedEventTaskYes" type="radio" 
                          (click)="searchEventEnable()" name="TaskuserdefinedorPredefinedEventTask"
                          [(ngModel)]="searchParam.SearchtaskUserdefinedorPredefinedModelEventTask" value='true'
                          class="form-check-input">
                        <label for="IsPredefinedEventTaskYes">Pre defined</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="IsPredefinedEventTaskNo" type="radio" 
                          (click)="searchEventEnable()" name="TaskuserdefinedorPredefinedEventTask"
                          [(ngModel)]="searchParam.SearchtaskUserdefinedorPredefinedModelEventTask" value='false'
                          class="form-check-input">
                        <label for="IsPredefinedEventTaskNo">User defined</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="radio-options-group">
                      <div class="md-radio md-radio-inline">
                        <input id="IsEmailSendYes" type="radio" (click)="enableSearchButton()"
                          name="IsEmailSend" [(ngModel)]="searchParam.IsEmailSend" [value]='true'
                          class="form-check-input">
                        <label for="IsEmailSendYes">ON</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="IsEmailSendNo" type="radio" (click)="enableSearchButton()"
                          name="IsEmailSend" [(ngModel)]="searchParam.IsEmailSend" [value]='false'
                          class="form-check-input">
                        <label for="IsEmailSendNo">OFF</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="radio-options-group">
                      <div class="md-radio md-radio-inline">
                        <input id="unapproved" type="radio" name="ApproveStatus" 
                          [(ngModel)]="searchParam.ApproveStatus" [value]='true' class="form-check-input">
                        <label for="unapproved">Unapproved</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="rejected" type="radio" name="ApproveStatus" 
                          [(ngModel)]="searchParam.ApproveStatus" [value]='false' class="form-check-input">
                        <label for="rejected">Rejected</label>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Row 3: Labels for Dropdowns and Buttons -->
                <div class="row filter-row-labels">
                  <div class="col-md-4">
                    <label class="form-control-label">Tag</label>
                  </div>
                  <div class="col-md-4">
                    <label class="form-control-label">Trigger ID</label>
                  </div>
                  <div class="col-md-4">
                    <!-- Empty for button alignment -->
                  </div>
                </div>

                <!-- Row 4: All Dropdowns and Action Buttons -->
                <div class="row filter-row-dropdowns">
                  <div class="col-md-4">
                    <div class="form-group">
                      <select id="groupdropdown" [(ngModel)]="searchParam.groupname" class="form-control select"
                        (change)="getSelectedGroupID($event)">
                        <option [value]=null>Select</option>
                        <option *ngFor="let group of groupTypes" value={{group._id}}>
                          {{group.GroupName}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <select id="triggerdropdown" [(ngModel)]="searchParam.triggerId" class="form-control select"
                        (click)="enableSearchButton()">
                        <option [value]=null>Select</option>
                        <option *ngFor="let taskTriggerType of taskTriggerTypes" value={{taskTriggerType._id}}>
                          {{taskTriggerType.Name}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="filter-actions">
                      <button type="button" [disabled]="response" (click)="showTasksBySearchDataEventTask(searchParam)"
                        class="btn btn-sm btn-primary" title="search">
                        <em class="fa fa-search"></em> &nbsp; Search
                      </button>
                      <button type="button" class="btn btn-sm btn-default btn-clear" (click)="showAllEventTasks()" title="refresh">
                        <em class="fa fa-refresh"></em> &nbsp; Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <div class="card-block  datatable-card-block">
              <div class="row">
                <div class="col-md-12">

                  <div class="dt-toolbar" *ngIf="isCheckerRole">
                    <form [formGroup]="activateTasksForm" class="form-inline well shiftToTable">
                     
                      <button id="btnactivateTasks" type="button" class="btn btn-sm btn-primary"
                        (click)="approveMultipleTasksConfirmation('event')" [disabled]="!addToProcessEventTask">
                        <em class="fa fa-check"></em>Approve/Reject</button>
                    </form>
                  </div>

                  <div class="table-responsive" style="position: relative;">
                    <!-- Loader overlay for Event Based Tasks -->
                    <div class="unapproved-task-loader-overlay" *ngIf="isLoading">
                      <div class="unapproved-task-loader-container">
                        <img src="assets/images/DigiCompany_loader.png" class="unapproved-task-spinner" alt="Loading..." />
                      </div>
                    </div>
                    <table datatable [dtOptions]="dtOptionsEventBasedTask" [dtTrigger]="dtTriggerEventBasedTask"
                      class="table table-hover compact cell-border nowrap stripe" id="eventLiberyTaskTable"
                      style="cursor: pointer;">
                      <caption></caption>
                      <thead>
                        <tr>
                          <th style="display:none">Task ID</th>

                          <th>
                            <div class="md-checkbox">
                              <input id="selectcheckboxallEventTask" class="md-checkbox" type="checkbox"
                                [(ngModel)]="selectedAllEventTask" (change)="checkIfAllSelectedEvent()" />
                              <label for="selectcheckboxallEventTask">&nbsp;</label>
                            </div>
                          </th>
                          <th class="companyTask-list-column">Task Name </th>
                          <th>Task Description </th>
                          <th class="companyTask-list-column">Global/Company Specific </th>
                          <th class="companyTask-list-column">Tag</th>

                          <th class="companyTask-list-action" >Action</th>
                          <th class="companyTask-list-action" style="display:none">Meeting Type</th>
                          <th class="companyTask-list-action" style="display:none">Assigned To</th>
                          <th class="companyTask-list-action" style="display:none">Due Date (in days)</th>
                          <th class="companyTask-list-action" style="display:none">Trigger Id</th>
                        </tr>
                      </thead>

                      <tbody>
                        <tr *ngFor="let companytask of libraryEventBasedTaskList; let count=index"
                          [ngClass]="{'inActiveCompanyTasks':companytask.IsActive==false,'activeCompanyTasks':companytask.IsActive==true}">
                          <td style="display: none">{{companytask.TaskID}}</td>

                          <td>
                            <div class="md-checkbox">
                              <input id="selectcheckboxForEvent{{count +1 }}" type="checkbox"
                                [(ngModel)]="companytask.SelectedTask" (change)="selectcheckboxForEvent();"
                                (change)="checkselectedEvent($event,companytask.IsActive, companytask.TriggerType, count);">
                              <label for="selectcheckboxForEvent{{count +1 }}">&nbsp;</label>
                            </div>
                          </td>
                          <!-- <td>{{count+1}}</td> -->
                          <td class="companyTask-list-column">{{companytask.TaskName }}</td>
                          <td>{{companytask.TaskDescription }}</td>
                          <td class="companyTask-list-column"><span *ngIf="companytask.IsGlobal">Global</span> <span
                              *ngIf="!companytask.IsGlobal">Company
                              Specific
                            </span></td>
                          <td class="companyTask-list-column">{{companytask.GroupName }}</td>

                          <td class="companyTask-list-action" >

                            <button *ngIf="companytask.IsActive===true" type="button" class="btn-sm btn btn-warning"
                              (click)="EditEventBasedTask(companytask.ID)"
                              [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                              <span class="fa fa-pencil"></span>
                            </button>
                            <button type="button" *ngIf="isCheckerRole" class="btn-sm btn btn-info"
                              (click)="approveTaskStatusConfirmation(companytask.ID, companytask.type)">
                              <span class="fa fa-check-circle"></span>
                            </button>
                            <!-- <button *ngIf="companytask.IsPredefined===false" type="button" class="btn-sm btn btn-danger"
                              (click)="deleteConfirmationEventBasedTask(companytask.ID)"
                              [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                              <span class="icmn-bin"></span>
                            </button> -->

                          </td>
                          <td class="companyTask-list-column" style="display:none">{{companytask.MeetingType }}</td>
                          <td class="companyTask-list-column" style="display:none">
                            {{companytask.AssignedUserName}}
                            <!-- {{getAssignTo(companytask.AssignedTo)}}</td> -->
                          <td class="companyTask-list-column" style="display:none">{{companytask.CompletionDays }}</td>
                          <td class="companyTask-list-column" style="display:none">{{companytask.TriggerName }}</td>
                        </tr>
                      </tbody>

                    </table>
                  </div>

                </div>
              </div>
            </div>




          </section>
        </div>

        <div class="tab-pane " id="periodicTaskTab" role="tabcard">
          <section class="card">
            <!--  header: Periodic -->
            <!-- <div class="card-header">
              <span class="cat__core__title">
                <strong>Periodic Based Task</strong>
              </span>
            </div> -->

            <!-- Search Filter : Periodic -->
            <section class="card search-box">
              <div class="card-header" (click)="toggleSearchCollapse()" style="cursor: pointer;">Modify Search <span
                  class="pull-right"><i class="fa fa-filter" aria-hidden="true"></i></span> </div>
              <div class="card-block" id="search-div2" *ngIf="!isSearchCollapsed">
                <!-- Row 1: Labels for Dropdowns -->
                <div class="row filter-row-labels">
                  <div class="col-md-4">
                    <label class="form-control-label">Tag</label>
                  </div>
                  <div class="col-md-4">
                    <label class="form-control-label">Task Status</label>
                  </div>
                  <div class="col-md-4">
                    <label class="form-control-label">Trigger ID</label>
                  </div>
                </div>

                <!-- Row 2: All Dropdowns -->
                <div class="row filter-row-dropdowns">
                  <div class="col-md-4">
                    <div class="form-group">
                      <select id="groupdropdown" [(ngModel)]="searchPeriodicParam.groupname" class="form-control select"
                        (change)="getSelectedGroupID($event)">
                        <option [value]=null>Select</option>
                        <option *ngFor="let group of groupTypes" value={{group._id}}>
                          {{group.GroupName}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <select id="taskStatusdropdown" [(ngModel)]="searchPeriodicParam.selcettaskname"
                        [formControl]="activateTasksForm.controls['TaskStatus']" class="form-control select"
                        (change)="getSelectedTaskStatus($event)">
                        <option [value]="null"> All </option>
                        <option value="Active">Active</option>
                        <option value="InActive">Inactive</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <select id="triggerIddropdown" [(ngModel)]="searchPeriodicParam.triggerId" class="form-control select"
                        (click)="isEnableButtonSearch()">
                        <option [value]=null>Select</option>
                        <option *ngFor="let taskTriggerType of taskTriggerTypes" value={{taskTriggerType._id}}>
                          {{taskTriggerType.Name}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Row 3: Labels for Radio Options and Buttons -->
                <div class="row filter-row-labels">
                  <div class="col-md-3">
                    <label class="form-control-label">User defined / Pre defined</label>
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label">Emails</label>
                  </div>
                  <div class="col-md-3">
                    <label class="form-control-label">Approve Status</label>
                  </div>
                  <div class="col-md-3">
                    <!-- Empty for button alignment -->
                  </div>
                </div>

                <!-- Row 4: All Radio Button Options and Action Buttons in One Line -->
                <div class="row filter-row-options-single">
                  <div class="col-md-3">
                    <div class="radio-options-group">
                      <div class="md-radio md-radio-inline">
                        <input id="IsPrePeriodicTaskYes" type="radio" 
                          name="TaskuserPredefinedPeriodicTask" (click)="periodicSerchDefindTask()"
                          [(ngModel)]="searchPeriodicParam.SearchtaskUserdefinedorPredefinedModelPeriodicTask"
                          [value]='true' class="form-check-input">
                        <label for="IsPrePeriodicTaskYes">Pre defined</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="IsPrePeriodicTaskNo" type="radio" 
                          name="TaskuserPredefinedPeriodicTask" (click)="periodicSerchDefindTask()"
                          [(ngModel)]="searchPeriodicParam.SearchtaskUserdefinedorPredefinedModelPeriodicTask"
                          [value]='false' class="form-check-input">
                        <label for="IsPrePeriodicTaskNo">User defined</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="radio-options-group">
                      <div class="md-radio md-radio-inline">
                        <input id="IsEmailSendYesPeriodic" type="radio"
                          (click)="isEnableButtonSearch()" name="IsEmailSendNoPeriodicTask"
                          [(ngModel)]="searchPeriodicParam.IsEmailSend" [value]='true' class="form-check-input">
                        <label for="IsEmailSendYesPeriodic">ON</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="IsEmailSendNoPeriodic" type="radio"
                          (click)="isEnableButtonSearch()" name="IsEmailSendNoPeriodicTask"
                          [(ngModel)]="searchPeriodicParam.IsEmailSend" [value]='false' class="form-check-input">
                        <label for="IsEmailSendNoPeriodic">OFF</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="radio-options-group">
                      <div class="md-radio md-radio-inline">
                        <input id="unapproved1" type="radio"
                          name="ApproveStatus1" [(ngModel)]="searchPeriodicParam.ApproveStatus" [value]='true'
                          class="form-check-input">
                        <label for="unapproved1">Unapproved</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="rejected1" type="radio"
                          name="ApproveStatus1" [(ngModel)]="searchPeriodicParam.ApproveStatus" [value]='false'
                          class="form-check-input">
                        <label for="rejected1">Rejected</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="filter-actions">
                      <button type="button" [disabled]="response"
                        (click)="showTasksBySearchDataPeriodic(searchPeriodicParam)" class="btn btn-sm btn-primary"
                        title="search">
                        <em class="fa fa-search"></em> &nbsp; Search
                      </button>
                      <button type="button" [disabled]="response" class="btn btn-sm btn-default btn-clear"
                        (click)="showAllPeriodicTasks()" title="refresh">
                        <em class="fa fa-refresh"></em> &nbsp; Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <div class="card-block  datatable-card-block">
              <div class="row">
                <div class="col-md-12">
                  <div class="dt-toolbar" *ngIf="isCheckerRole">
                    <form [formGroup]="activateTasksForm" class="form-inline well shiftToTable">
                      <button id="btnactivateTasks" type="button" class="btn btn-sm btn-primary"
                        (click)="approveMultipleTasksConfirmation('periodic')" [disabled]="!periodicTaskCheck">
                        <i class="fa fa-check"></i>Approve/Reject</button>
                    </form>
                  </div>
                  <!--Periodic DataTable  -->
                  <div class="margin-bottom-50">
                    <div class="table-responsive" style="position: relative;">
                      <!-- Loader overlay for Periodic Tasks -->
                      <div class="unapproved-task-loader-overlay" *ngIf="isLoading">
                        <div class="unapproved-task-loader-container">
                          <img src="assets/images/DigiCompany_loader.png" class="unapproved-task-spinner" alt="Loading..." />
                        </div>
                      </div>
                      <table datatable [dtOptions]="dtOptionsforPeriodicTask" [dtTrigger]="dtTriggerforPeriodicTask"
                        id="PeriodicTaskDataTable" class="table table-hover compact cell-border nowrap stripe"
                        style="cursor: pointer;">
                        <thead>
                          <tr>
                            <th style="display:none">Task ID</th>

                            <th>
                              <div class="md-checkbox">
                                <input id="checkboxForPeriodicTask" class="md-checkbox" type="checkbox"
                                  [(ngModel)]="checkAllPeriodicTask" (change)="selectAllPeriodicTask($event);" />
                                <label for="checkboxForPeriodicTask">&nbsp;</label>
                              </div>
                            </th>
                            <th class="companyTask-list-column">Task Name </th>
                            <th>Task Description </th>
                            <th class="companyTask-list-column">Global/Company Specific </th>
                            <th class="companyTask-list-column">Tag</th>

                            <th class="companyTask-list-action" >Action</th>
                            <th class="companyTask-list-action" style="display:none">Meeting Type</th>
                            <th class="companyTask-list-action" style="display:none">Assigned To</th>
                            <th class="companyTask-list-action" style="display:none">Due Date (in days)</th>
                            <th class="companyTask-list-action" style="display:none"> Trigger Id</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr *ngFor="let periodictask of periodicTaskList; let count=index"
                            [ngClass]="{'inActiveCompanyTasks':periodictask.IsActive==false,'activeCompanyTasks':periodictask.IsActive==true}">
                            <td style="display: none">{{periodictask.TaskID}}</td>

                            <td>
                              <div class="md-checkbox">
                                <input id="selectedAllPeriodic{{count +1 }}" type="checkbox"
                                  [(ngModel)]="periodictask.SelectedTask"
                                  (change)="checkselected($event,periodictask.IsActive);">
                                <label for="selectedAllPeriodic{{count +1 }}">&nbsp;</label>
                              </div>
                            </td>

                            <td class="companyTask-list-column">{{periodictask.TaskName }}</td>
                            <td>{{periodictask.TaskDescription }}</td>
                            <td class="companyTask-list-column"><span *ngIf="periodictask.IsGlobal">Global</span> <span
                                *ngIf="!periodictask.IsGlobal">Company
                                Specific
                              </span></td>
                            <td class="companyTask-list-column">{{periodictask.GroupName }}</td>

                            <td class="companyTask-list-action" >

                              <button *ngIf="periodictask.IsActive===true" type="button" class="btn-sm btn btn-warning"
                                (click)="EditPeriodicBasedTask(periodictask.ID)"
                                [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                                <span class="fa fa-pencil"></span>
                              </button>
                              <button type="button" *ngIf="isCheckerRole" class="btn-sm btn btn-info"
                                (click)="approveTaskStatusConfirmation(periodictask.ID, periodictask.type)">
                                <span class="fa fa-check-circle"></span>
                              </button>
                              <!-- <button *ngIf="periodictask.IsPredefined===false" type="button"
                                class="btn-sm btn btn-danger"
                                (click)="deleteConfirmationPeriodicBasedTask(periodictask.ID)"
                                [appHasPermission]="{'Url': '/tasks/library/edit?goveva=true&email=', 'method':'put', 'menu': 'LibraryTask'}">
                                <span class="icmn-bin"></span>
                              </button> -->

                            </td>
                            <td style="display:none">{{periodictask.MeetingType }}</td>
                            <td style="display:none">
                              <!-- {{ getAssignTo(periodictask.AssignedTo) }} -->
                              {{ periodictask.AssignedUserName }}
                            </td>
                            <td style="display:none">{{periodictask.CompletionDays }}</td>
                            <td style="display:none">{{periodictask.TriggerName }}</td>
                          </tr>
                        </tbody>

                      </table>

                    </div>

                  </div>
                </div>
              </div>
            </div>

          </section>
        </div>

        <div class="modal fade modal-size-medium" id="addtasktoprocessDialogEventTask" tabindex="-1" role="dialog"
          aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog">
            <form [formGroup]="activateTasksForm" class="well">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="myModalLabel">process</h5>
                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div class="modal-body">

                  <div class="row">

                    <div class="col-md-6">
                      <label class="form-control-label" for="l0"> (Pre defined / User defined)
                      </label>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">

                        <div class="md-radio md-radio-inline">
                          <input id="IsPreDefined" type="radio"
                            [formControl]="activateTasksForm.controls['IsPredefinedorUserdefined']"
                            style="position:absolute" name="IsPredefinedorUserdefined" value="Predefined"
                            (click)="CheckProcessType('Predefined')" class="form-check-input">
                          <label for="IsPreDefined">Pre defined</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="IsUserDefined" type="radio"
                            [formControl]="activateTasksForm.controls['IsPredefinedorUserdefined']"
                            style="position:absolute" name="IsPredefinedorUserdefined" value="Userdefined"
                            (click)="CheckProcessType('Userdefined')" class="form-check-input">
                          <label for="IsUserDefined">User defined</label>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label" for="l0">Select Process
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <select [formControl]="activateTasksForm.controls['ProcessID']" class="form-control select">
                          <option value=""> Select </option>
                          <option *ngFor="let process of processes" value={{process._id}}>
                            {{process.ProcessName}}
                          </option>
                        </select>
                        <div
                          *ngIf="activateTasksForm.controls['ProcessID'].hasError('required') && activateTasksForm.controls['ProcessID'].touched"
                          class="form-control-error-custom">
                          Process is required.
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
                <div class="modal-footer">

                  <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary" data-dismiss="modal"
                    [disabled]='!activateTasksForm.valid || disabledOnclick' (click)="addTaskstoProcess()"><i
                      class="fa fa-save"></i>Save
                  </button>

                  <button type="button" class="btn btn-sm" data-dismiss="modal"> <i
                      class="fa fa-times"></i>Close</button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="modal fade" id="confirmationEventTask" tabindex="-1" role="dialog" aria-labelledby=""
          aria-hidden="true" style="top: 50px;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDelete">
                  <i class="fa fa-question-circle-o mr-2"></i>Confirm
                </h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-12">
                    Are you sure you want to delete this Task?
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-danger" (click)="deleteTask()">
                  <i class="fa fa-check"></i>Yes
                </button>
                <button type="button" class="btn btn-sm" data-dismiss="modal">
                  <i class="fa fa-times"></i>No
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="modal fade modal-size-medium" id="configureSettingsDialog" tabindex="-1" role="dialog"
          aria-labelledby="" aria-hidden="true">
          <div class="modal-dialog">
            <form [formGroup]="taskConfigurationForm" class="well">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="myModalLabel">Configuration</h5>
                  <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div class="modal-body">

                  <!-- <div class="row">

                    <div class="col-md-6">
                      <label class="form-control-label" for="l0"> (Pre defined / User defined)
                      </label>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">

                        <div class="md-radio md-radio-inline">
                          <input id="IsPreDefined" type="radio" [formControl]="activateTasksForm.controls['IsPredefinedorUserdefined']" style="position:absolute"
                            name="IsPredefinedorUserdefined" value="Predefined" (click)="CheckProcessType('Predefined')" class="form-check-input">
                          <label for="IsPreDefined">Pre defined</label>
                        </div>
                        <div class="md-radio md-radio-inline">
                          <input id="IsUserDefined" type="radio" [formControl]="activateTasksForm.controls['IsPredefinedorUserdefined']" style="position:absolute"
                            name="IsPredefinedorUserdefined" value="Userdefined" (click)="CheckProcessType('Userdefined')"
                            class="form-check-input">
                          <label for="IsUserDefined">User defined</label>
                        </div>

                      </div>
                    </div>
                  </div> -->
                  <div class="row">
                    <div class="col-md-6">
                      <label class="form-control-label" for="l0">Select Default Assigned User
                        <span _ngcontent-c2="" style="color: red;">*</span>
                      </label>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <select [formControl]="taskConfigurationForm.controls['UserId']" class="form-control select"
                          (change)="selectedUserChange()">
                          <option value=""> Select </option>
                          <option *ngFor="let user of assignedusers" value={{user._id}}>
                            {{user.FirstName + " "+ user.LastName}}
                          </option>
                        </select>
                        <div
                          *ngIf="taskConfigurationForm.controls['UserId'].hasError('required') && taskConfigurationForm.controls['UserId'].touched"
                          class="form-control-error-custom">
                          User is required.
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
                <div class="modal-footer">

                  <button id="btnsaveTasktoProcess" type="button" class="btn btn-sm btn-primary"
                    [disabled]='!taskConfigurationForm.valid || disabledOnclick'
                    (click)="addPeriodicTaskConfiguration()"><i class="fa fa-save"></i>Save </button>

                  <button type="button" class="btn btn-sm" data-dismiss="modal"> <i
                      class="fa fa-times"></i>Close</button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="modal fade" id="approveTaskStatusDialog" tabindex="-1" role="dialog" aria-labelledby=""
          aria-hidden="true" style="top: 50px;">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="myModalLabelForDelete">
                  <i class="fa fa-question-circle-o mr-2"></i>Confirm
                </h5>
                <button aria-label="Close" class="close" data-dismiss="modal" type="button">
                  <i class="fa fa-times"></i>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-6">
                    Are you sure you want to approve/reject this Task?
                  </div>
                  <div class="col-sm-6">
                    <div class="input-group" style="display: unset;">
                      <div class="md-radio md-radio-inline">
                        <input id="approveYes" type="radio" style="position:absolute" name="approve"
                          [(ngModel)]="approveCheck" value='true' class="form-check-input">
                        <label for="approveYes">Approve</label>
                      </div>
                      <div class="md-radio md-radio-inline">
                        <input id="approveNo" type="radio" style="position:absolute" name=" approve"
                          [(ngModel)]="approveCheck" value='false' class="form-check-input">
                        <label for="approveNo">Reject</label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row"></div>
                <div class="row" *ngIf="approveCheck == 'false'">
                  <div class="col-sm-6">
                    Comment:
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <textarea class="form-control" [(ngModel)]="taskRejectComment"></textarea>
                    </div>
                  </div>
                </div>
                <div class="row"
                  *ngIf="approveCheck == 'true' && (saveType == 'addAndActivate' || saveType == 'updateAndActivate')">
                  <div class="col-sm-6">
                    Task Particulars:
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <textarea class="form-control" [(ngModel)]="taskParticulars"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-sm btn-primary" (click)="approveTask()"
                  *ngIf="approveBtnType == 'single'">
                  <i class="fa fa-check"></i>Save
                </button>
                <button type="button" class="btn btn-sm btn-primary" (click)="approveMultipleTasks()"
                  *ngIf="approveBtnType == 'multi'">
                  <i class="fa fa-check"></i>Save
                </button>
                <button type="button" class="btn btn-sm" data-dismiss="modal">
                  <i class="fa fa-times"></i>Cancel
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</section>
<app-alert></app-alert>